export default __webpack_public_path__ + "static/media/Ballroll_00307.edeaef1c.png";